import React, { ReactElement, ReactNode } from 'react';

import usePostTestEvent, { ISendTestEventHook } from './send-test-event-hook';

const SendTestEventContext = React.createContext<ISendTestEventHook>({} as never);

interface IProps {
  children: ReactNode;
}

export const SendTestEventProvider = (props: Readonly<IProps>): ReactElement => {
  return <SendTestEventContext.Provider value={usePostTestEvent()}>{props.children}</SendTestEventContext.Provider>;
};

export const useSendTestEventContextProvider = (): ISendTestEventHook => React.useContext<ISendTestEventHook>(SendTestEventContext);
